<ul
    class="list-flat"
    [ngClass]="{
        'list-flat--svg': svg,
        'list-flat--usps': usp,
        'list-flat--expanded': expanded,
        'list-flat--numbered': numbered,
        'list-flat--lined': lined,
        'list-flat--table': table,
    }"
>
    <ng-container
        *ngFor="let item of listFlatItems; trackBy: trackByIndex"
        [ngTemplateOutlet]="item.listFlatItem"
        [ngTemplateOutletContext]="{ icon: icon }"
    ></ng-container>
</ul>
